// extracted by mini-css-extract-plugin
export default {"root":"ProductCardList_root__ZZ66b","banner":"ProductCardList_banner__i5EQl"};